export enum PlayersQueryKeys {
  Statistics = '/players/statistics',
}
